import React from 'react'
import styles from './swagger-api.module.css'

const HideDeprecatedCheckbox = ({ checked, onClick }) => {
  return (
    <label className={styles.hideDeprecatedCheckbox}>
      <input
        type="checkbox"
        name="hideDeprecated"
        value="hide"
        onClick={onClick}
        checked={checked}
      />
      <small>Hide deprecated</small>
    </label>
  )
}

export default HideDeprecatedCheckbox
